(function () {
  // require('../../scss/main.scss');
  require('./jquery.carousel.js');

  var FormTabsEngine = require('./form-tabs-engine');
  var hpFormsOptions = require('./forms-defaults')();
  var PreparePostInit = require('./prepare-post-init-functions');

  hpFormsOptions = PreparePostInit(hpFormsOptions, []);

  var hpForms = new FormTabsEngine({
    
    'form-1': ['airticketForm', hpFormsOptions.letenky],
    'form-2': ['ybusForm', hpFormsOptions.jizdenky]
  });

  // otevirame form airticket, pokud na nej prichaime ze substranek (je poslane url #form-2)
  if (window.location.href.split('#')[1] == 'form-2') {

    // fix na IE, kde se stranka odskrolovala dolu
    var timer = setInterval(function(){

      if ($(window).scrollTop() > 0) {
        $(window).scrollTop(0);
        clearInterval(timer);
      }

    }, 10);

    hpForms.init('form-2');
    $('.tabs').tabs('option', 'active', 1); // toto nam odkryje tab, ktery chceme (jQuery UI Tabs)
    $('html, body').animate({
        scrollTop: 0
    }, 500);
  }
  else {
    hpForms.init('form-1');
  }

  // incializace formulare letenek pri kliknuti na tlacitko v menu
  $('.footer-menu ul li:last-child a').click(function (e) {
    e.preventDefault();
    window.initAirTicket();
  });

  window.initAirTicket = function(top) {
    hpForms.init('form-2');
    $('.tabs').tabs('option', 'active', 1); // toto nam odkryje tab, ktery chceme (jQuery UI Tabs)
    $('html, body').animate({
        scrollTop: 0
    }, 500);
  };

  $('.hp-special-offers #letenky .content').airticketOffersWidget({
    component_id: 'studentagency.de',
    count: 10,
    random: 5
  });

  // homepage banner slider
  $('.infinite-carousel').infiniteCarousel();

  // hover state na iframz, protoze IE neumi hover na iframe v CSS
   window.iframeHoverState();
})();



// WEBPACK FOOTER //
// ./src/js/homepage/index.js